import DateFnsUtils from '@date-io/date-fns'
import { Grid, Typography } from '@material-ui/core'
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import React, { useContext, useEffect } from 'react'
import { CategoryContext } from '../../../context api/Category/CategoryContext'
import { ConfigurationContext } from '../../../context api/Configuration/ConfigurationContext'
import { ProductContext } from '../../../context api/Product/ProductContext'
import { useLeadType } from '../../../hooks/CompanyConfiguration/useLeadType'
import { useCategory } from '../../../hooks/Features/useCategory'
import { useProduct } from '../../../hooks/Features/useProduct'
import { calculateMonthRange, getNumbersByValidity, sortByName, validityOptions } from '../../../shared/constants'
import CustomInput from '../../CustomInput'
import CustomSelect from '../../CustomSelect'
import MultipleSelectInput from '../../MultipleSelectInput'
import MultiSelectInput from '../../MultiSelectInput'

import { makeStyles } from '@material-ui/core'
import { useStore } from '../../../hooks/CompanyConfiguration/useStore'
import CustomAddForm from '../../version-4/MasterForms/CustomAddForm'
import { useTarget } from '../../../hooks/CompanyConfiguration/useTarget'
const useStyles = makeStyles((theme) => ({
  displayNone: {
    dispaly: 'none',
  },
}))

export default function SchemeForm({ form, setForm, store, setStore, product, setProduct }) {
  const { name, date, category, schemeBasedOn, validity, schemeType, saleValue, incentive, schemeFrom, schemeTo, schemeCode, noOfMonths, schemeFor } = form
  const classes = useStyles()
  //console.log('FORM : ', form)
  const { getAllCategories } = useCategory()
  const { products } = useContext(ProductContext)
  const { categories } = useContext(CategoryContext)
  const { stores, targets } = useContext(ConfigurationContext)

  const { getAllProducts } = useProduct()
  const { getAllStore } = useStore()
  const { getAllTarget } = useTarget()

  useEffect(() => {
    if (category && category !== '') {
      getAllProducts({ categoryId: category })
    } else {
      getAllProducts()
      setForm({ ...form, category: null })
    }
  }, [schemeBasedOn, category])

  useEffect(() => {
    getAllCategories()
    getAllTarget()
    getAllStore()
  }, [])

  // let tempStores = targets && targets.map((item) => item.store)
  // tempStores = new Set(tempStores['_id'])

  const basedOnOptions = [
    { label: 'Category', value: 'CATEGORY' },
    { label: 'Product', value: 'PRODUCT' },
  ]
  const inputField = [
    { label: 'Scheme Code', value: schemeCode, name: 'schemeCode' },
    { label: 'Name', value: name, name: 'name' },
    // { label: 'Date', date: true },

    {
      label: 'Validity',
      value: validity,
      name: 'validity',
      options: validityOptions,
      // noDisplay: schemeBasedOn === 'Category' ? false : true,
      fieldName: 'label',
      fieldValue: 'value',
    },
    {
      label: `Number of ${validity && validity.toLowerCase().substring(0, validity.length - 2)}`,
      value: noOfMonths,
      name: 'noOfMonths',
      options: getNumbersByValidity(validity),
      noDisplay: validity && validity !== 'CUSTOM' ? false : true,
    },

    {
      label: 'From',
      value: schemeFrom,
      name: 'schemeFrom',
      type: 'DATE',
    },
    {
      label: 'To',
      value: validity === 'CUSTOM' ? schemeTo : calculateMonthRange(schemeFrom, noOfMonths, validity),
      name: 'schemeTo',
      type: 'DATE',
      disabled: validity === 'CUSTOM' ? false : true,
    },
    {
      label: 'Scheme For',
      value: schemeFor,
      name: 'schemeFor',
      options: [
        { label: 'All', value: 'ALL' },
        { label: 'New Stores', value: 'NEW' },
        { label: 'Old Stores', value: 'OLD' },
      ],
      fieldName: 'label',
      fieldValue: 'value',
    },
    {
      label: 'Scheme Type',
      value: schemeType,
      name: 'schemeType',
      options: [
        { label: 'Fixed', value: 'FIXED' },
        { label: 'Per Lakh', value: 'PER LAKH' },
        { label: 'Target Based', value: 'TARGET BASED' },
      ],
      fieldName: 'label',
      fieldValue: 'value',
    },
    {
      label: 'Sale Amount',
      value: saleValue,
      name: 'saleValue',
      type: 'NUMBER',
      noDisplay: schemeType !== 'FIXED' ? true : false,
    },
    {
      label: 'Incentive Amount',
      value: incentive,
      name: 'incentive',
      type: 'NUMBER',
      noDisplay: !schemeType ? true : false,
    },

    {
      label: 'Scheme Based On',
      value: schemeBasedOn,
      name: 'schemeBasedOn',
      display: true,
      options: basedOnOptions,
      select: true,
      fieldName: 'label',
      fieldValue: 'value',
    },

    {
      label: 'Category',
      value: category,
      name: 'category',
      select: true,
      options: categories,
      noDisplay: schemeBasedOn === 'Category' || schemeBasedOn === 'CATEGORY' ? false : true,
      fieldName: 'categoryName',
      fieldValue: '_id',
    },
    {
      label: 'Products',
      value: product,
      name: 'mustOrder',
      options: sortByName(products, 'products'),
      noDisplay: schemeBasedOn ? false : true,
      grid: 12,
      fieldName: 'name',
      fieldName2: 'sku',
      fieldValue: '_id',
      handleChange: setProduct,
      type: 'MULTI',
      conditions: [{ cond: (value) => value.length < 1, message: 'You have to Select at least one Product' }],
    },
    {
      label: 'Store',
      value: store,
      name: 'store',
      type: 'MULTI',
      options: sortByName(stores),
      noDisplay: schemeBasedOn ? false : true,
      grid: 12,
      fieldName: 'name',
      fieldValue: '_id',
      handleChange: setStore,
      conditions: [{ cond: (value) => value.length < 1, message: 'You have to Select at least one Store' }],
    },
  ]

  return <CustomAddForm state={form} setState={setForm} data={inputField} />
}
